module.exports = {
      id: "logout-usage",
      viewBox: "0 0 18.6 21.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#logout-usage",
      toString: function () {
        return this.url;
      }
    }